import { render, staticRenderFns } from "./DictionaryWords.vue?vue&type=template&id=3cb7005c&scoped=true&"
import script from "./DictionaryWords.vue?vue&type=script&lang=js&"
export * from "./DictionaryWords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb7005c",
  null
  
)

export default component.exports